import React, { useState } from 'react';
import { IconButton } from '@mui/material';
import { TeamMember } from '@marageti/z4-sdk/lib/people';
import { TripRequest, TripRequestStatus } from '@marageti/z4-sdk/lib/travel';
import { OutlinedIcons } from '@marageti/z4-lib';
import TripRequestDetailCard from './trip-request-card';
import TripRequestEditModal from '../modals/trip-request-edit-modal';

const { OutlinedPencilIcon: Edit } = OutlinedIcons;

type Props = {
  chips?: string[];
  tripRequest: TripRequest;
  onEditSuccess: () => void;
  title?: string;
  loggedInTeamMember: TeamMember | null;
};

const TripRequestDetails = ({
  chips,
  tripRequest,
  onEditSuccess,
  title = 'Request Details',
  loggedInTeamMember,
}: Props) => {
  const [editModalOpen, setEditModalOpen] = useState(false);

  const toggleEditModal = () => {
    setEditModalOpen(!editModalOpen);
  };

  const handleSuccess = () => {
    onEditSuccess();
    toggleEditModal();
  };

  return (
    <>
      <TripRequestDetailCard
        chips={chips}
        title={title}
        tripRequest={tripRequest}
        loggedInTeamMember={loggedInTeamMember}
        action={tripRequest?.status !== TripRequestStatus.CanceledStatus && (
          <IconButton onClick={toggleEditModal}>
            <Edit color="primary" fontSize="small" />
          </IconButton>
        )}
      />
      <TripRequestEditModal
        open={editModalOpen}
        onClose={toggleEditModal}
        onSuccess={handleSuccess}
        tripRequest={tripRequest}
      />
    </>
  );
};

export default TripRequestDetails;
